// 获取iframe url的链接参数
export interface IframeParams {
  iframeId: string | null
  userId: string | null
  vehicleId: string | null
}
declare global {
  interface Window {
    iframeParams: IframeParams | null
  }
}
export const setIframeParams = () => {
  // 获取链接参数
  const queryString = window.location.href.split('#/?')[1] || ''
  // 将参数转换为对象
  const params = new URLSearchParams(queryString)
  // 提取id和vid的值
  console.log('====================================')
  console.log(params)
  console.log('====================================')
  const iframeId = params.get('uuid')
  const userId = params.get('userId')
  const vehicleId = params.get('vehicleId')
  window.iframeParams = {
    iframeId,
    userId,
    vehicleId,
  }
  console.log('================window.iframeParams====================')
  console.log(window.iframeParams)
  console.log('====================================')
}
